/* eslint-disable promise/param-names */
import { settings } from "@/settings";
const state = {
  appName: settings.APP_NAME,
  appMainTitle: settings.APP_MAINTITLE,
  appSubTitle: settings.APP_SUBTITLE
};

const getters = {
  appName: state => state.appName,
  appMainTitle: state => state.appMainTitle,
  appSubTitle: state => state.appSubTitle
};

const actions = {};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
